import { gql, useQuery } from '@apollo/client'

import {
  RecentViewedItemConnectionFragmentDoc,
  RecentViewedItemsQuery,
  RecentViewedItemsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ artistId: string }>()
  const artistId =
    config.applicationType === 'standalone'
      ? config.artistId
      : router.query.artistId
  const { data, loading, fetchMore } = useQuery<
    RecentViewedItemsQuery,
    RecentViewedItemsQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      artistId,
    },
  })

  return {
    state: {
      hasNextPage: !!data?.recentlyStoreViewedItems?.pageInfo.hasNextPage,
      loading,
      artistId: artistId ?? '#',
      items: data?.recentlyStoreViewedItems ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            artistId,
            pageInput: {
              cursor: data?.recentlyStoreViewedItems?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query RecentViewedItems($pageInput: PageInput, $artistId: String) {
    recentlyStoreViewedItems(pageInput: $pageInput, artistId: $artistId) {
      ...RecentViewedItemConnection
    }
  }
  ${RecentViewedItemConnectionFragmentDoc}
`
